export const environment = {
  production: false,
  apiUrl: 'https://dev.truth-api.cmgservicing.com/',
  msalConfig: {
    auth: {
      clientId: 'c9ca2c26-0fad-4baa-9e9e-e38c6198fda4',
      authority: 'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://b36f7659-a2e4-4aef-a7f9-64a85e47ced7/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/'
  }
};
